module.exports = __webpack_public_path__ + "img/3.78c15b40.png";